import { Chip, ChipProps, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(
  theme => ({
    dayChip: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      backgroundColor: theme.palette.aegis.semantic.border.dark
    },
    label: {
      padding: 0,
      fontSize: 14
    }
  }),
  { name: 'DayChip' }
);

interface DayChipProps extends ChipProps {
  label: string;
}

export default function DayChip({ label, ...props }: DayChipProps) {
  const classes = useStyles();

  return (
    <Chip
      label={label}
      {...props}
      classes={{
        label: classes.label
      }}
      className={classes.dayChip}
    />
  );
}
